/* eslint-disable react/no-access-state-in-setstate,no-shadow, no-unused-vars */
import React from 'react';
import { connect } from 'react-redux';
import Switch from 'react-ios-switch';
import InfoTooltip from '../../../common/tooltip/info/index';
import GeneralTableSubRow from '../sub-row';
import requestPageContainer from '../../../../containers/hr/request-page';
import { withNamespaces } from 'react-i18next';

class GeneralTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.isSelected = this.isSelected.bind(this);
    this.switchOnChange = this.switchOnChange.bind(this);

    this.state = {
      subRequestShow: false,
      openRequests: false,
    };
  }

  isSelected() {
    const { selectedRequests, employmentId } = this.props;

    if (selectedRequests.length > 0) {
      const request = selectedRequests.find(
        request => request.employmentId === employmentId);

      return request.selected;
    }

    return false;
  }

  switchOnChange(selected) {
    const { employmentId, pageCount, selectRequest } = this.props;

    selectRequest(selected, employmentId, pageCount);
  }

  render() {
    const {
      requests, employee, uploaded, t
    } = this.props;

    return (
      <div className="requests hr-requests">
        <div className="requests-header">
          <div className="row">
            <div className="col-md-2">
              <h5>
                { employee.employeeName }
              </h5>
            </div>
            <div className="col-md-8" style={{ padding: '5px' }}>
              <div className="row">
                {
                                    this.props.amounts.yi ? (
                                      <div className="col-md-6">
                                        <label>
                                                    {t('domesticAllowanceAmount')}
                                        </label>
                                        <input
                                          type="text"
                                          value={this.props.amounts.yi}
                                          style={{ width: '100%' }}
                                        />
                                      </div>
                                    )
                                      : null
                                }

                {
                                    this.props.amounts.yd ? (
                                      <div className="col-md-6">
                                        <label>
                                        {t('overseansAllowanceAmount')}
                                        </label>
                                        <input
                                          type="text"
                                          value={this.props.amounts.yd}
                                          style={{ width: '100%' }}
                                        />
                                        <br />
                                        <br />
                                      </div>
                                    )
                                      : null
                                }
                {
                                    this.props.amounts.ybk ? (
                                      <div className="col-md-6">
                                        <label>
                                        {t('domesticIndividualAccommodationAmount')}
                                        </label>
                                        <input
                                          type="text"
                                          value={this.props.amounts.ybk}
                                          style={{ width: '100%' }}
                                        />
                                      </div>
                                    )
                                      : null
                                }

                {
                                    this.props.amounts.ydbk ? (
                                      <div className="col-md-6">
                                        <label>
                                        {t('overseasIndividualAccommodationAmountInfo')}
                                        </label>
                                        <input
                                          type="text"
                                          value={this.props.amounts.ydbk}
                                          style={{ width: '100%' }}
                                        />
                                      </div>
                                    )
                                      : null
                                }
              </div>
            </div>
            <div
              className="col-md-2"
              style={{ padding: '10px', paddingRight: '12px' }}
            >
              <span className="pull-right">
                {
                    !uploaded
                      ? (
                        <Switch
                          checked={this.isSelected()}
                          onChange={(checked) => { this.switchOnChange(checked); }}
                        />
                      )
                      : (
                        <InfoTooltip info={t('approvedInfo')}>
                          <span className="fa fa-2x fa-check text-success" />
                        </InfoTooltip>
                      )
                }

              </span>
            </div>
          </div>
        </div>
        <div
          className="requests-content"
          style={{
            marginTop: '15px',
            display: (this.state.openRequests ? 'block' : 'none'),
          }}
        >
          <div className="requests-column">
            <div className="row">
              <div className="col-md-1">
                <h5>
                {t('status')}
                </h5>
              </div>
              <div className="col-md-2">
                <h5>
                {t('travelDate')}
                </h5>
              </div>
              <div className="col-md-2">
                <h5>
                {t('reasonForTravel')}
                </h5>
              </div>
              <div className="col-md-2">
                <h5>
                {t('cityCounty')}
                </h5>
              </div>
              <div className="col-md-1">
                <InfoTooltip info={t('travelExpensesGross')}>
                  <h5>
                  {t('travelExpensesGross')}
                  </h5>
                </InfoTooltip>
              </div>
              <div className="col-md-2">
                <InfoTooltip info={t('individualAccommodationNet')}>
                  <h5>
                  {t('individualAccommodationNet')}
                  </h5>
                </InfoTooltip>
              </div>
              <div className="col-md-2">
                <h5>
                {t('transaction')}
                </h5>
              </div>
            </div>
          </div>
          <div className="request-list">
            {
                            requests.map((request, key) => (
                              <GeneralTableSubRow
                                key={request.id || request._id}
                                request={request}
                                employee={employee}
                              />
                            ))
                        }
          </div>
        </div>
        <div
          className="open-requests"
          onClick={() => {
            this.setState({ openRequests: !this.state.openRequests });
          }}
        >
          <i className={`fa ${
            !this.state.openRequests ? 'fa-angle-down' : 'fa-angle-up'}`}
          />
        </div>
      </div>
    );
  }
}


export default withNamespaces()(connect(...requestPageContainer)(GeneralTableRow));



// WEBPACK FOOTER //
// ./src/components/hr/components/row/index.js